module.exports = __webpack_public_path__ + "img/neotag-product3.c28a946d.jpg";